<template>
  <div>
    <Profile />
    <p class="text-h4 text-sm-h3 ma-6">Experience</p>
    <Timeline />
  </div>
</template>

<script>
import Timeline from "../components/About/Timeline";
import Profile from "../components/About/Profile";

export default {
  components: {
    Profile,
    Timeline,
  },
};
</script>
